import { useAuth } from '@workos-inc/authkit-react';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi } from '../api/api.context';

export const useAuthActions = () => {
  const api = useApi();
  const { signIn, signOut } = useAuth();

  const location = useLocation();

  let returnToUrl = location.pathname;
  if (location.search) {
    returnToUrl += location.search;
  }

  const signInHandler = useCallback(() => {
    signIn({ state: { returnTo: returnToUrl } });
  }, [returnToUrl, signIn]);

  const signOutHandler = useCallback(async () => {
    try {
      await api.appController.logout();
    } catch {
    } finally {
      signOut();
    }
  }, [api, signOut]);

  return {
    signIn: signInHandler,
    signOut: signOutHandler
  };
};
